var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1640_9150)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 235.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 295.992C356 363.921 315.243 406.683 250.5 406.683C185.757 406.683 145 363.921 145 295.992C145 223.097 220.63 124.689 243.826 96.2247C244.651 95.2134 245.675 94.4015 246.828 93.8449C247.981 93.2882 249.235 93 250.504 93C251.773 93 253.027 93.2882 254.179 93.8449C255.332 94.4015 256.356 95.2134 257.182 96.2247C280.37 124.689 356 223.097 356 295.992Z",
    fill: "#FEF4E8",
    stroke: "black",
    strokeWidth: 10.7175,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.969 302.141C314.969 316.819 309.411 330.897 299.519 341.276C289.626 351.655 276.209 357.486 262.219 357.486",
    fill: "#FEF4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.969 302.141C314.969 316.819 309.411 330.897 299.519 341.276C289.626 351.655 276.209 357.486 262.219 357.486",
    stroke: "#4045A1",
    strokeWidth: 19.0533,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1640_9150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.ddde8d5b6bae6d0fe991e9f3cf958a55.svg";
export { ForwardRef as ReactComponent };